import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API, withCredentials: true, headers: { "X-Requested-With": "XMLHttpRequest" } });

export function errMsg(e, fallback = "Si è verificato un errore. Riprova.") {
  const d = e?.response?.data?.detail;
  if (!d) return e?.response?.status === 429 ? "Troppe richieste. Riprova tra qualche minuto." : fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || "").filter(Boolean).join(" ") || fallback;
  return d.msg || fallback;
}

function leadingZeroBits(buf, bits) {
  const b = new Uint8Array(buf);
  let i = 0;
  while (bits >= 8) { if (b[i++] !== 0) return false; bits -= 8; }
  return bits === 0 || b[i] >> (8 - bits) === 0;
}

export async function solvePow() {
  const { data } = await api.get("/public/challenge");
  const enc = new TextEncoder();
  for (let start = 0; start < 5_000_000; start += 256) {
    const batch = await Promise.all(Array.from({ length: 256 }, (_, k) =>
      crypto.subtle.digest("SHA-256", enc.encode(data.challenge + (start + k))).then((h) => [start + k, h])));
    const hit = batch.find(([, h]) => leadingZeroBits(h, data.bits));
    if (hit) return { challenge: data.challenge, nonce: String(hit[0]) };
  }
  throw new Error("pow");
}

export async function download(url, filename, headers = {}) {
  const res = await api.get(url, { responseType: "blob", headers });
  const href = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = href;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(href), 2000);
}

export const fmtDate = (d) => (d ? new Date(d).toLocaleDateString("it-IT", { day: "2-digit", month: "long", year: "numeric" }) : "—");
export const fmtDateTime = (d) => (d ? new Date(d).toLocaleString("it-IT", { dateStyle: "short", timeStyle: "short" }) : "—");
export const fmtSize = (n) => (n > 1048576 ? `${(n / 1048576).toFixed(1)} MB` : `${Math.max(1, Math.round(n / 1024))} KB`);
